import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import classes from "./Breadcrumb.module.scss";

const breadcrumbObjectModel = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  url: PropTypes.string,
};

export const Breadcrumb = ({ items, selectedId }) => {
  const navigate = useNavigate();
  return (
    <div className={classes["wrapper"]}>
      {items.map((item, index) => (
        <div
          className={`${classes["item"]} ${
            selectedId === item.id ? classes["selected"] : ""
          }`}
          key={item.id}
          data-testid={"wrapper"}
          onClick={() => {
            navigate(item.url);
          }}
        >
          <div className={classes["item-number"]}>{index + 1}</div>
          <div className="fw-bold title-primary">{item.title}</div>
          <div className="font-14 font-gray">{item.subtitle}</div>
        </div>
      ))}
    </div>
  );
};

Breadcrumb.propTypes = {
  /**
   * items of the breadcrumb
   */
  items: PropTypes.arrayOf(PropTypes.exact(breadcrumbObjectModel)).isRequired,
  /**
   * set the item id to identify it as a selected item
   */
  selectedId: PropTypes.number,
};

Breadcrumb.defaultProps = {
  selectedId: 0,
};
